import Swiper, { Navigation, Pagination } from 'swiper';

const swiperWithBox = () => {
  const swiperBox = document.querySelector('.js--swiper-with-box');

  if (swiperBox) {
    const slides = swiperBox.querySelectorAll('.swiper-slide');
    if (slides.length > 0) {
      const carousel = swiperBox.querySelector('.swiper__carousel');
      const btnPrev = carousel.querySelector('.swiper__btn--prev');
      const btnNext = carousel.querySelector('.swiper__btn--next');
      const box = document.querySelector('.js--box');

      slides.forEach(slide => {
        const figure = slide.querySelector('.panel');
        const figureHeight = figure.offsetHeight;

        if (figureHeight < box.offsetHeight) {
          figure.style.minHeight = `${box.offsetHeight}px`;
        }
      });

      const swiper = new Swiper(swiperBox, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        loop: false,
        rewind: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper__btn--next',
          prevEl: '.swiper__btn--prev',
        },
        on: {
          slideChange: function () {
            let currSlideText = slides[swiper.realIndex].dataset.title;
            let currSlidePerex = slides[swiper.realIndex].dataset.perex;
            let currSlidePerex2 = slides[swiper.realIndex].dataset.perex2;
            let currSlidePerex3 = slides[swiper.realIndex].dataset.perex3;
            let currSlidePerex4 = slides[swiper.realIndex].dataset.perex4;
            let currSlidePerex5 = slides[swiper.realIndex].dataset.perex5;

            let content = `<div>
                              <h2 class="section__title text-white js--box__title">${currSlideText}</h2>
                              <div class="perex js--box__perex text-justify">
                                  <p>${currSlidePerex || ''}</p>
                                  <p>${currSlidePerex2 || ''}</p>
                                  <p>${currSlidePerex3 || ''}</p>
                                  <p>${currSlidePerex4 || ''}</p>
                                  <p>${currSlidePerex5 || ''}</p>
                              </div>
                          </div>`;

            box.innerHTML = content;
          },
        },
      });

      btnNext.addEventListener('click', () => {
        for (let i = 0; i < slides.length; i++) {
          // You can add any logic here for when the next button is clicked
        }
      });
    }
  }
}

export default swiperWithBox;
